import React, { useState } from "react";
import {
  Grid,
  Button,
  Avatar,
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  ListItemText,
  Box,
  Divider,
  Dialog,
  DialogContent,
  Select,
  TextField,
  DialogTitle,
  InputLabel,
  FormControl,
  Alert,
  DialogActions,
} from "@mui/material";
import { getTokenData, removeAccessToken } from "../../utils/Utils";
import PostAddIcon from "@mui/icons-material/PostAdd";
import ColorModeSwitch from "./ColorModeSwitch";
import { logout } from "../../services/Access";
import { useAuth } from "../../context/AuthContext";
import LogoutIcon from "@mui/icons-material/Logout";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import { sendContactMessage } from "../../services/Contact";

export default function Index(props) {
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [openContactDialog, setOpenContactDialog] = useState(false);
  const [reason, setReason] = useState("");
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const username = getTokenData()?.email || "User";
  const avatarLetter = username.trim().charAt(0).toUpperCase() || "U";
  const isMenuOpen = Boolean(menuAnchorEl);

  const handleOpenMenu = (event) => {
    setMenuAnchorEl(event.currentTarget);
  };

  const handleCloseMenu = () => {
    setMenuAnchorEl(null);
  };

  const handleLogout = () => {
    removeAccessToken();
    logout().then(() => {
      window.location.href = "./";
    });
  };

  const sendContact = () => {
    if (!reason || !message) {
      setError("Por favor, preencha todos os campos."); //trad
      return;
    }
    sendContactMessage({ reason, message })
      .then(() => {
        setMessage("");
        setReason("");
        setError(""); //trad
        setSuccess("Mensagem enviada com sucesso!"); //trad
      })
      .catch(() => {
        setError("Erro ao enviar mensagem. Tente novamente mais tarde."); //trad
        setSuccess("");
      });
  };

  const setCloseContactDialog = (value) => {
    setOpenContactDialog(value);
    setError("");
    setSuccess("");
  };

  return (
    <>
      <div
        position="fixed"
        style={{
          zIndex: 999999,
          position: "absolute",
          backgroundColor: /* darkMode ? "#090e12" : */ "#1e2f3f",
          height: "40px",
          width: "100%",
          backgroundImage:
            localStorage.getItem("kowalskiMode") === "true"
              ? "url(./img/kowalski_analyzer.png)"
              : "url(./img/gridparser.png)",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "9px center",
        }}
      >
        <Grid container style={{ "-webkit-app-region": "drag" }}>
          <Grid item xs={12} pr={20} sx={{ textAlign: "right" }}>
            {/* {user && ( */}
            {1 && (
              <>
                <Button
                  variant="contained"
                  startIcon={<PostAddIcon />}
                  onClick={props.handleOpenLayouts}
                  size="small"
                  style={{ "-webkit-app-region": "no-drag" }}
                >
                  Layouts{/* trad */}
                </Button>

                <span
                  style={{ "-webkit-app-region": "no-drag", marginLeft: "8px" }}
                >
                  <IconButton onClick={handleOpenMenu} size="small">
                    <Avatar
                      sx={{
                        width: 30,
                        height: 30,
                        fontSize: "0.9rem",
                        bgcolor: "#3f6389",
                      }}
                    >
                      {avatarLetter}
                    </Avatar>
                  </IconButton>
                </span>

                <Menu
                  anchorEl={menuAnchorEl}
                  open={isMenuOpen}
                  onClose={handleCloseMenu}
                  PaperProps={{ style: { minWidth: "140px" } }}
                >
                  <Box
                    sx={{
                      alignItems: "center",
                      display: "flex",
                      flexDirection: "column",
                    }}
                  >
                    <ColorModeSwitch
                      handleChangeTheme={props.handleChangeTheme}
                    />
                  </Box>
                  <Divider></Divider>

                  <MenuItem onClick={() => setOpenContactDialog(true)}>
                    <ListItemIcon>
                      <ContactSupportIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>
                      Contato{/*trad */}
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    </ListItemText>
                  </MenuItem>

                  <Divider></Divider>
                  <MenuItem onClick={() => handleLogout()}>
                    <ListItemIcon>
                      <LogoutIcon fontSize="small" />
                    </ListItemIcon>
                    <ListItemText>Logout{/*trad */}</ListItemText>
                  </MenuItem>
                </Menu>
              </>
            )}
          </Grid>
        </Grid>
      </div>

      <Dialog
        open={openContactDialog}
        onClose={() => setCloseContactDialog(false)}
        fullWidth
      >
        <DialogTitle>Contato{/*trad */}</DialogTitle>
        <DialogContent>
          <Box sx={{ display: "flex", flexDirection: "column" }} mt={2}>
            <FormControl fullWidth size="small">
              <InputLabel id="reason">Motivo</InputLabel>
              <Select
                fullWidth
                label="Motivo" //trad
                id="reason-select"
                labelId="reason"
                value={reason}
                onChange={(e) => setReason(e.target.value)}
              >
                <MenuItem value="problema">Relatar um problema</MenuItem>
                {/*trad */}
                <MenuItem value="recurso">Solicitação de recurso</MenuItem>
                {/*trad */}
                <MenuItem value="melhoria">Sugestão de melhoria</MenuItem>
                {/*trad */}
                <MenuItem value="outro">Outro</MenuItem>
                {/*trad */}
              </Select>
            </FormControl>
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column" }} mt={2}>
            <TextField
              multiline
              rows={4}
              label="Escreva sua mensagem" //trad
              value={message}
              onChange={(e) => setMessage(e.target.value)}
            />
          </Box>
          <Box sx={{ display: "flex", flexDirection: "column" }} mt={2}>
            <Button
              variant="contained"
              color="primary"
              onClick={() => sendContact()}
            >
              Enviar
            </Button>
          </Box>
          {error && (
            <Box sx={{ display: "flex", flexDirection: "column" }} mt={2}>
              <Alert severity="error">{error}</Alert>
            </Box>
          )}
          {success && (
            <Box sx={{ display: "flex", flexDirection: "column" }} mt={2}>
              <Alert severity="success">{success}</Alert>
            </Box>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              setCloseContactDialog(false);
            }}
          >
            Fechar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
